import { EHubDetailMutations, } from './types';
const mutations = {
    [EHubDetailMutations.RESET_HUB_INFO](state) {
        state.hubInfo = null;
    },
    [EHubDetailMutations.GET_HUB_INFO](state, payload) {
        state.hubInfo = payload;
    },
};
export default mutations;
